import { render, staticRenderFns } from "./ParlamentarList.vue?vue&type=template&id=6af65a09&scoped=true&"
import script from "./ParlamentarList.vue?vue&type=script&lang=js&"
export * from "./ParlamentarList.vue?vue&type=script&lang=js&"
import style0 from "./ParlamentarList.vue?vue&type=style&index=0&id=6af65a09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af65a09",
  null
  
)

export default component.exports